import { useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../../services/api.service';

export default function useResetTourMobileConnection() {
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Rend une tournée à nouveau connectable depuis le mobile.
   * @param {number} tourId - L'identifiant de la tournée
   * @param {boolean} moveToToday - Replacer la tournée au jour courant
   * @param {boolean} resetChecklist - Faire refaire la checklist de départ
   * @param {boolean} resetExecution - Remettre les étapes à leur état planifié
   * @returns {Promise<object|null>} La tournée mise à jour, ou null en cas d'erreur
   */
  const resetTour = async (
    tourId,
    moveToToday = true,
    resetChecklist = false,
    resetExecution = false
  ) => {
    try {
      setIsLoading(true);

      const response = await fleetApi.post(
        `/super-admin/tours/${tourId}/reset-mobile-connection`,
        {
          move_to_today: moveToToday,
          reset_checklist: resetChecklist,
          reset_execution: resetExecution,
        }
      );

      if (response.status !== 200) {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }

      toast.success(
        "Tournée débloquée : le mobile peut à nouveau s'y connecter."
      );

      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    resetTour,
  };
}
